import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

export const toggleVariants = cva(
  twMerge([
    'rounded-full',
    `after:content-['']`,
    'after:absolute',
    'after:top-[2px]',
    'after:bg-white',
    'after:border-gray-300',
    'after:border',
    'after:rounded-full',
    'after:transition-all',
    'rtl:peer-checked:after:-translate-x-full',
    'peer-focus:outline-none',
    'peer-checked:after:translate-x-full'
  ]),
  {
    variants: {
      variant: {
        primary: twMerge([
          'bg-aux-gray',
          'peer-checked:after:border-white',
          'peer-checked:bg-emerge-teal'
        ]),
        secondary: twMerge([
          'bg-emerge-navy-2',
          'peer-checked:after:border-white',
          'peer-checked:bg-emerge-teal'
        ])
      },
      size: {
        sm: twMerge([
          'w-10',
          'h-6',
          'after:start-[2px]',
          'after:h-5',
          'after:w-5',
          'peer-checked:after:start-[-2px]'
        ]),
        lg: twMerge(['w-16', 'h-6', 'after:start-[4px]', 'after:h-5', 'after:w-7'])
      }
    },
    defaultVariants: {
      variant: 'primary',
      size: 'sm'
    }
  }
);
